import { Component, Vue, Prop } from 'vue-property-decorator'
import { IMatchup, IPick } from '@/store/modules/game/interfaces'
import { IMatchupType } from './Matchup'

@Component
export default class Loader extends Vue implements IMatchupType {
  @Prop() matchup: IMatchup;
  
  private render(h: any): any {

    return (
      <div class='avatar-card overunder loader personal'>
        <div class='avatar'>
          <div class='lds-ellipsis'><div></div><div></div><div></div><div></div></div>
        </div>
      </div>
    );
  }
}
